<template>
  <div>
 

 <div style="min-height:120px;"></div>
  <div class="container-fluid mt--6">

     <div class="card">
        <div class="border-0 card-header">
            <h3 class="mb-0">Checklists</h3>
        </div>

        <el-table class="table-responsive table-flush"
                  header-row-class-name="thead-light"
                  :data="checklists">
            <el-table-column label="Name Of Checklist"
                             min-width="210px"
                             prop="checklist_name"
                             sortable>
                <template v-slot="{row}">
                    <div class="media align-items-center">
                        <div class="media-body">
                            <span class="font-weight-600 name mb-0 text-sm">{{row.checklist_name}}</span>
                        </div>
                    </div>
                </template>
            </el-table-column>
            
            
            
          <el-table-column label="Equipment Subtype"  min-width="210px" sortable prop="equipment_subtype.equipment_subtype_name">
          		<template v-slot="{row}">
                    <div class="">
                        <div v-for="eq_st in row.equipment_subtypes" class="" style="margin-bottom:20px;">
                            <span class="font-weight-600 name mb-0 text-sm">{{eq_st.equipment_subtype_name}}</span>
                            <br/>
                           	<span style="font-size:11px;">	
                           		<span class="font-weight-600 name mb-0 ">Eq Type: </span><span> {{eq_st.equipment_type.equipment_type_name}}</span>
							</span>
                        </div>
                    </div>
                </template>
          
          </el-table-column>
             
             
            
           <el-table-column min-width="180px" align="right" label="Actions">
                <div slot-scope="{$index, row}" class="d-flex">
                             

                  <base-button
                    @click.native="viewChecklist($index, row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                  >
                Edit
                  </base-button>
                  
                
                  
                  
                </div>
            </el-table-column>   	
           
        </el-table>

       
    </div>
</div>
<!-- end clients list -->    
 <div style="min-height:120px;"></div>

    
 <div class="container-fluid mt--6">
    
	  <!--start new row-->
      
      <div class="row">
        <div class="col-lg-6">
          <div class="card-wrapper">
            <!-- Input groups -->
            <card>
              <!-- Card header -->
              <h3 slot="header" class="mb-0">Create Checklist</h3>
              <!-- Card body -->
              <form class="needs-validation"   @submit.prevent="submit_form">
                <!-- Input groups with icon -->
        
                <div class="row">
                  <div class="col-md-12">
                  
                  <base-input label="Checklist Name"
                      name="checklist name"
                      placeholder=""
                      required
                      v-model="model.checklist_name">
          			</base-input>
          
          
        
                  </div>
                  <div class="col-md-6">
                  </div>
                </div>
                
                 <!-- end row -->
                 
                 
                
                
                

                
            
            
            <div class="row">
                  <div class="col-md-12">
                  
                  <div style="margin-top:20px;">
                  <h4 style="color:#999">* One Equipment Subtype can only have one checklist assigned to it.</h4>
                  </div>
                
 						<el-table class="table-responsive table-flush"
						  header-row-class-name="thead-light"
						  :data="et_subtype_all_options">
						  
					  <el-table-column  align="left" label="Select Equipment Subtype (Eq Type)">
						<div slot-scope="{$index, row}" class="d-flex">
							 

						  <base-input >
							 <base-checkbox v-model="model.est_checkboxes[row.value]" > 
								
								 <span class="font-weight-600 name mb-0 text-sm">{{row.label}}</span>
							  </base-checkbox>
							</base-input> 
				  
				
				  
				  
						</div>
					</el-table-column>   
					
					
				

			 
			
				 	
		   
				</el-table>
				
				
                
                  </div>
                </div>
                <!-- end row -->
                
             
                
                <base-input label="Remarks">
                    <textarea class="form-control" v-model="model.remarks"  rows="3"></textarea>
                 </base-input>
                  
                  
                
                <div>
                <base-button type="info" block native-type="submit">Create Checklist</base-button>
                </div>
              
              </form>
            </card>
            </div>
            </div>
            </div>
            



    
    </div>  <!--End container-->
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>
  import { Select, Option, Table, TableColumn, Tabs, TabPane,} from 'element-ui'
  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';
  

  export default {
    components: {
  	  [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      TabPane,
      Tabs,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
      return {
     	 checklists:[],
     	 
     	 model:{
     	 	client_name:'',
     	 	client_address:'',
     	 	contact_number:'',
     	 	client_email: '',
     	 	contact_person: '',
     	 	remarks:'',
     	 	client_type:1,
     	 	est_checkboxes:[],
     	 },
     	 et_type_options:[],
     	 et_subtype_options:[],
     	 et_subtype_all_options:[],
     	 client_type_options: [
          {
            label: 'Company',
            value: 1
          },
          {
            label: 'Individual',
            value: 2
          },
        ],
	
      };
    },
    methods: {
  		submit_form(){
  				swal.showLoading();
  				var vm = this;
  				let uri = vm.$base_url+'/api/checklists/post/create_checklist';
				ApiService.post(uri, vm.model).then(response => {
			 		if(response.data.success == "y"){
			 				swal.fire({
									title: `Success`,
									text: 'Checklist Created.',
									buttonsStyling: false,
									confirmButtonClass: 'btn btn-success',
									icon: 'success'
							});
							
							vm.page_load();
			 		}
			 		else{
			 			swal.fire({
									title: 'Error',
									text: response.data.error,
									buttonsStyling: false,
									confirmButtonClass: 'btn btn-success',
									icon: 'warning'
							});
			 			
			 		}
			 })//end api service
  		},
  		viewChecklist(index, row) {
  			this.$router.push( '/manage-checklist/'+row.id)
  		
  		},
  	
  		et_change(){
  			
  			this.et_subtype_options = this.et_subtype_all_options[this.model.equipment_type][0];
  			this.model.equipment_subtype = this.et_subtype_options[0]['value'];
			
  		},
  		page_load(){
  			swal.showLoading();
			let uri = this.$base_url+'/api/checklists/get/list';
			 ApiService.get(uri).then(response => {
			 
				 const vm = this;
				 this.checklists = response.data.checklists;
				 this.et_subtype_all_options = response.data.est_arr;
				 this.model.est_checkboxes = response.data.est_checkboxes;
				 swal.close();
   
			})
  		
  		
  		
  		},
  		to_confirm(){
  			
  		
  			var vm = this;
  			swal.fire({
					title: 'Are you sure?',
					text: 'You are changing the password for the virtual tour to:     '+ this.model.code,
					type: 'warning',
					showCancelButton: true,
					confirmButtonClass: 'btn btn-success btn-fill',
					cancelButtonClass: 'btn btn-danger btn-fill',
					confirmButtonText: 'Yes, proceed.',
					buttonsStyling: false
				  }).then((result)=> {	
				  
				  		 if (result.isConfirmed) {
				  		 	 var $base_url = "https://kh.rollingatlas.com/kh/public";
				  			 let uri = vm.$base_url+'/api/change_code';
							 ApiService.post(uri, vm.model).then(response => {
			 						if(response.data.success == "y"){
			 							vm.code = response.data.code;
			 							swal.fire({
												title: `Success`,
												text: 'Virtual Tour Password Updated.',
												buttonsStyling: false,
												confirmButtonClass: 'btn btn-success',
												icon: 'success'
										 });
			 						}
			 				})
				  		 
				  		 }
				  		 else{
				  		 
				  		 
				  		 }
				  			
			 
					}
					
					)//end swal

  		}
    },
    mounted() {
      	
      	this.page_load();
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














